var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Config } from "./config";
import { chitraCSRFTokenAPI, chitraTokenBackendAPI } from "./chitraSlice";
import { ChitraToken, CSRFToken } from "./url";
import { env } from "../../api/config";
var CHITRA_ENDPOINT = '';
if (env === "dev") {
    CHITRA_ENDPOINT = "https://dev-superset.excellonconnect.com";
}
if (env === "lt") {
    CHITRA_ENDPOINT = "https://lt-superset.excellonconnect.com";
}
export var ChitraLogin = function (response, dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var chitra_endpoint, Chitra_Endpoint, parsedData, userName, email, url, loginPageResponse, loginPageText, csrfTokenMatch, csrfToken, payload, loginResponse, access_token, csrf_token, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                chitra_endpoint = CHITRA_ENDPOINT;
                Chitra_Endpoint = '';
                if (chitra_endpoint) {
                    Chitra_Endpoint = chitra_endpoint;
                }
                if (!response) return [3 /*break*/, 9];
                parsedData = response.payload;
                userName = parsedData === null || parsedData === void 0 ? void 0 : parsedData.getCache.Owner;
                email = parsedData === null || parsedData === void 0 ? void 0 : parsedData.getCache.Username;
                url = "".concat(Chitra_Endpoint, "/login/");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 8, , 9]);
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        credentials: 'include'
                    })];
            case 2:
                loginPageResponse = _a.sent();
                if (!loginPageResponse.ok) {
                    throw new Error("Failed to load login page: ".concat(loginPageResponse.status));
                }
                return [4 /*yield*/, loginPageResponse.text()];
            case 3:
                loginPageText = _a.sent();
                csrfTokenMatch = loginPageText.match(/<input[^>]+name=["']csrf_token["'][^>]*value=["']([^"']+)["']/);
                if (!csrfTokenMatch) {
                    throw new Error('CSRF token not found');
                }
                csrfToken = csrfTokenMatch[1];
                payload = new URLSearchParams({
                    "csrf_token": csrfToken,
                    "username": userName,
                    "password": email
                });
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
                            'Referer': "".concat(chitra_endpoint, "/login"),
                            'Origin': "".concat(chitra_endpoint)
                        },
                        body: payload.toString()
                    })];
            case 4:
                loginResponse = _a.sent();
                if (!loginResponse.ok) {
                    throw new Error("Login failed: ".concat(loginResponse.status));
                }
                return [4 /*yield*/, dispatch(chitraTokenBackendAPI({
                        userName: userName,
                        email: email
                    })).unwrap()];
            case 5:
                access_token = _a.sent();
                if (!access_token) return [3 /*break*/, 7];
                return [4 /*yield*/, dispatch(chitraCSRFTokenAPI({
                        access_token: access_token
                    })).unwrap()];
            case 6:
                csrf_token = _a.sent();
                localStorage.setItem(ChitraToken, access_token);
                localStorage.setItem(CSRFToken, csrf_token);
                _a.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                error_1 = _a.sent();
                console.error('Error during Chitra login:', error_1);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}); };
export var ChitraLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
    var chitra_endpoint, Chitra_Endpoint, url, logoutPageResponse, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                chitra_endpoint = Config.CHITRA_ENDPOINT;
                Chitra_Endpoint = '';
                if (chitra_endpoint) {
                    Chitra_Endpoint = chitra_endpoint;
                }
                url = "".concat(Chitra_Endpoint, "/logout/");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        credentials: 'include'
                    })];
            case 2:
                logoutPageResponse = _a.sent();
                if (!logoutPageResponse.ok) {
                    throw new Error("Failed to load login page: ".concat(logoutPageResponse.status));
                }
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                console.error('Error during Chitra login:', error_2);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
